import { render, staticRenderFns } from "./addHeader.vue?vue&type=template&id=a0e80746&scoped=true&"
import script from "./addHeader.vue?vue&type=script&lang=js&"
export * from "./addHeader.vue?vue&type=script&lang=js&"
import style0 from "./addHeader.vue?vue&type=style&index=0&id=a0e80746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e80746",
  null
  
)

export default component.exports